module.exports = __webpack_public_path__ + "img/num1.1bcc8791.png";